<script>
  import './style.scss';
  import template from './template.html';
  import { TagIcon, CloseIcon } from '../../../icons.js';
  import ClickOutside from 'vue-click-outside';
  
  export default {
    props: {
      data: Object
    },
    
    computed: {
      
      tags () {
        return this.data['Order Tags'].split(',');
      }
    },
    
    methods: {
      
      tagClicked ($event, tag) {
        this.$emit('tag', {$event, tag});
      },
      
      tagsList () {
        let str = "";
        
        let stripHtml = (str) => {
          return str.replace(/&nbsp;/g, ' ');
        };
        
        this.tags.forEach((tag, indx) => {
          let t = stripHtml(tag);
          let comma = indx == this.tags.length - 1 ? '' : ', ';
          
          str += t + comma;
        });
        
        return str;
      },
      
      toggleOrderTags (show) {
        if (show !== undefined) {
          this.showTags = show;
          return;
        }
        
        this.showTags = !this.showTags;
      },
      
      encodeTag (tag) {
        return encodeURIComponent(tag);
      },
      
      getIcon (name) {
        return `${name}Icon`
      },
      
      clickedOutside () {
        setTimeout(() => {
          
          if (this.showTags) {
            this.showTags = false;
          }
        })
      }
    },
    
    template,
    
    components: {
      TagIcon,
      CloseIcon
    },
    
    directives: {
      ClickOutside
    },
    
    data () {
      return {
        showTags: false
      }
    }
  };
</script>
